import { z } from "zod";
import {
  CURRICULUM_NOTES,
  DESIGNATION,
  EMAIL,
  INCLUDES_3D_PRINTER,
  INCLUDES_CHAIRS,
  INCLUDES_ELECTRICAL,
  INCLUDES_PAINTING,
  INCLUDES_PODIUM_MIC,
  INCLUDES_STORAGE_CABINETS,
  INCLUDES_TABLETS,
  INCLUDES_TEACHERS_TABLE,
  INCLUDES_TV,
  INFRASTRUCTURE_NOTES,
  NAME,
  OTHER_NOTES,
  PHONE,
  POC_DETAILS,
} from "./consts";

export const schema = z.object({
  [POC_DETAILS]: z
    .object({
      [NAME]: z.string().optional(),
      [EMAIL]: z.string().optional(),
      [PHONE]: z
        .string()
        .regex(/^(\+?1?[2-9][0-9]{2}[2-9][0-9]{6})?$/, "Invalid Phone Number")
        .optional(),
      [DESIGNATION]: z.string().optional(),
    })
    .array()
    .optional(),
  [INCLUDES_TV]: z.boolean().optional(),
  [INCLUDES_3D_PRINTER]: z.boolean().optional(),
  [INCLUDES_PAINTING]: z.boolean().optional(),
  [INCLUDES_ELECTRICAL]: z.boolean().optional(),
  [INCLUDES_STORAGE_CABINETS]: z.boolean().optional(),
  [INCLUDES_TEACHERS_TABLE]: z.boolean().optional(),
  [INCLUDES_PODIUM_MIC]: z.boolean().optional(),
  [INCLUDES_TABLETS]: z.boolean().optional(),
  [INCLUDES_CHAIRS]: z.boolean().optional(),
  [INFRASTRUCTURE_NOTES]: z.string().optional(),
  [CURRICULUM_NOTES]: z.string().optional(),
  [OTHER_NOTES]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
